import React from 'react';
import { Link } from 'react-router';
import { Row, Col, Button, Image } from 'react-bootstrap';
import fuzzyFilterFactory from 'react-fuzzy-filter';
import { LinkContainer } from 'react-router-bootstrap';
import editcampaign from '../../images/edit-campaign.png';
import PaginatedList from '../../components/PaginatedList';
import SidebarFilterBox from '../../components/SidebarFilterBox';

export default class IndustrySidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showArchived: false,
      filterValue: ''
    };
    this.sidebarFuzzyFilterFactory = fuzzyFilterFactory();
    this.updateFilterValue = this.updateFilterValue.bind(this);
  }

  componentDidMount() {
    this.props.getIndustries();
  }

  updateFilterValue(filterValue) {
    this.setState({ filterValue: filterValue || '' });
  }

  moveFocusToHeading = item => {
    this.setState({ currentItemName: item.name }, () =>
      this.screenReaderContent.focus()
    );
  };

  render() {
    const industryId = this.props.params.industryId || 'new';

    const LineItem = props => {
      const industry = props.item;
      return (
        <Row
          key={industry.id}
          className={`sidebar-list-item ${industry.isArchived && 'archived'}`}
          onClick={e => this.moveFocusToHeading(industry)}
        >
          <Link to={`/industries/${industry.id}`}>
            <Col
              sm={10}
              className={`overflow-ellipsis map-link ${industryId ===
                industry.id.toString() && 'active'}`}
            >
              <p title={industry.name} className="single-line">
                <strong>{industry.name}</strong>
              </p>
            </Col>
          </Link>
          <Link to={`/industries/${industry.id}`}>
            <Col sm={2} className="edit-btn text-center campaign-edit-link">
              <Image src={editcampaign} responsive alt="Edit Industry" />
              <span className="campaign-edit-link-text">Edit</span>
            </Col>
          </Link>
        </Row>
      );
    };

    return (
      <div className="generic-sidebar">
        <Row>
          <Col sm={12} md={6}>
            <h3
              className="screen-reader-only"
              tabIndex="-1"
              ref={i => (this.screenReaderContent = i)}
            >
              Editing industry {this.state.currentItemName}
            </h3>
            <h1>Industries</h1>
          </Col>

          <Col sm={12} md={6}>
            <div className="sidebar-new-btn">
              <LinkContainer to="/industries/new">
                <Button bsStyle="primary" className="new-btn">
                  Create New
                </Button>
              </LinkContainer>
            </div>
          </Col>

          <Col sm={12}>
            <SidebarFilterBox
              onChange={this.updateFilterValue}
              fuzzyFilterFactory={this.sidebarFuzzyFilterFactory}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <PaginatedList
              filterValue={this.state.filterValue}
              component={LineItem}
              items={this.props.industries}
              showArchived={this.state.showArchived}
              fuzzyFilterFactory={this.sidebarFuzzyFilterFactory}
              pluralName="industries"
            />
          </Col>
        </Row>

        <Row>
          <Col sm={12} md={12} lg={12} className="show-archived-wrapper">
            <div className="checkbox-wrapper">
              <input
                type="checkbox"
                name="archiveCheckbox"
                id="archiveCheckbox"
                className="archive-checkbox"
                checked={this.state.showArchived}
                onChange={() =>
                  this.setState({ showArchived: !this.state.showArchived })
                }
              />
              <label htmlFor="archiveCheckbox" className="checkbox-label">
                Show Archived
              </label>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/sidebars/IndustrySidebar.js